import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { ModalDialogComponent, ModalDialogHost } from '../modal-dialog.component';

export interface ConfirmationModalOptions {
    headerText?: string,
    message: string,
    okayText?: string,
    cancelText?: string
}

declare const $: any;


@Component({
    moduleId: module.id.toString(),
    selector: 'yeti-confirmaton-modal',
    template: require('./confirmation-modal.html')
})

export class ConfirmationModalComponent implements ModalDialogHost {

    headerText: string;
    message: string;
    okayText: string;
    cancelText: string;

    modalClose = new EventEmitter<any>();
    readyForDestruction = new EventEmitter<any>();

    constructor() {

    }

    init(options: ConfirmationModalOptions) {
        this.headerText = options.headerText || "Confirmation";
        this.message = options.message;
        this.okayText = options.okayText || "Yes";
        this.cancelText = options.cancelText || "No";

        //$('yeti-modal .yeti-button-yes').focus();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/modal-dialog/confirmation-modal/confirmation-modal.component.ts